import React from "react";
import { Flex, Icon, Text, Box } from "@costar/theme-ui";
export var NoData = function (_a) {
    var message = _a.message;
    return (React.createElement(Box, { flexGrow: 2, bg: "white", width: "100%" },
        React.createElement(Flex, { "automation-id": "no-data-msg-container", flexDirection: "column", height: "100%", alignItems: "center", gap: "xl", pt: "100px" },
            React.createElement(Flex, { id: "logoContainer" },
                React.createElement(Icon, { icon: "costarLogo", width: 190, height: "52px", "automation-id": "logo" })),
            React.createElement(Text, { id: "message", "automation-id": "no-data-message" }, message === null || message === void 0 ? void 0 : message()))));
};
//# sourceMappingURL=NoData.js.map